export default function appendPunctuationMark(sourceString: string, targetString: string) {
  if (!sourceString) return targetString

  const lastChar = sourceString[sourceString.length - 1]
  if (!targetString.endsWith(lastChar) && lastChar.match(/[.!:;*?]/)) {
    return `${targetString}${lastChar}`
  }
  return targetString
}
